module.exports = __webpack_public_path__ + "img/77.6cade08f.png";